import { NEUTRAL_EQ } from "./state.js";
export function initialState(projectId) {
    return {
        projectId,
        sections: [],
        dnaReferences: [],
        dnaReference: null,
        masterEq: { ...NEUTRAL_EQ },
        sonicTraitsOverride: null,
        lastEventId: null,
    };
}
//# sourceMappingURL=initial.js.map